import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../button'
import './shapedButton.sass'

interface ShapedButtonProps {
    onclick: () => void
}

export const ShapedButton = ({ onclick }: ShapedButtonProps) => {
    const [t] = useTranslation()
    return <Button label={t('Filters')} onClick={onclick} className={'button shapedButton'} />
}
